import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { StepStatus } from "../models/stepStatus";

@Injectable({
  providedIn: "root"
})
export class StepStatusService {

    private createHeader() {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        };
        return httpOptions;
      }
         
    constructor(private httpClient: HttpClient) {}

    getStep(userId: string, planId: string) : Observable<StepStatus> {
        return this.httpClient.get<StepStatus>(`${environment.ApiEndpoint}/StepStatus/GetOrCreateStepStatusByUserId?userId=`+ userId + `&planId=` + planId, this.createHeader())   
        .pipe(
            map((data) => {return data;})
        )
    }

    updateStep(step: StepStatus) : Observable<StepStatus> {
        return this.httpClient.put<StepStatus>(`${environment.ApiEndpoint}/StepStatus/UpdateStepStatus`, step, this.createHeader());
    }

    deleteStep(userId: string, planId: string) {
      return this.httpClient.delete<string>(`${environment.ApiEndpoint}/StepStatus/DeleteStepStatusByUserIdAndPlanId?userId=` + userId + `&planId=` + planId, this.createHeader());
    }
}